import type { DevicesItemProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/DevicesTab/DevicesItem/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevicesItem - One audio device row, marked when it is the selected one
 *
 * The `deviceId` is shown because it is what persists, what the export
 * carries, and what a bug report has to name — the label is browser-chosen
 * and changes.
 */
export const DevicesItem: React.FC<DevicesItemProps> = ({
  device,
  isSelected,
}) => (
  <div
    className={cn(
      'flex items-center gap-2 border-t border-zinc-800 px-3 py-[9px] first:border-t-0',
      isSelected && 'bg-emerald-950'
    )}
  >
    <span className="flex w-3.5 flex-shrink-0 items-center justify-center text-[11px] font-bold text-emerald-400">
      {isSelected && (
        <>
          ✓<span className="sr-only">Selected</span>
        </>
      )}
    </span>

    <div className="min-w-0 flex-1">
      <div
        className={cn(
          'truncate text-[11.5px]',
          isSelected ? 'font-semibold text-zinc-200' : 'text-zinc-300'
        )}
      >
        {device.label || 'Label withheld by the browser'}
      </div>
      <div className="truncate font-sp-mono text-[10px] text-zinc-400">
        {device.deviceId}
      </div>
    </div>

    {device.deviceId === 'default' && (
      <span className="flex-shrink-0 rounded bg-zinc-800 px-[5px] py-0.5 text-[9.5px] font-semibold uppercase tracking-[0.05em] text-zinc-400">
        System
      </span>
    )}
  </div>
);
